import { htmlToText } from '@/utils/htmlToText';

export type RssImageCreditTag = 'media:credit' | 'media:description' | 'dc:creator' | 'media:copyright';

export type ResolveRssImageCreditParams = {
  imageCreditTag?: RssImageCreditTag | null;
  thumbnailCredit?: string | null;
  thumbnailCaption?: string | null;
  thumbnailCreator?: string | null;
  thumbnailCopyright?: string | null;
};

// Mirrors RSS_IMAGE_CREDIT_FALLBACK_TAGS in app/services/tiptap/components/shared/rss_methods.rb
const FALLBACK_CREDIT_TAGS: RssImageCreditTag[] = ['media:credit', 'media:copyright'];

export const resolveRssImageCredit = ({
  imageCreditTag,
  thumbnailCredit,
  thumbnailCaption,
  thumbnailCreator,
  thumbnailCopyright,
}: ResolveRssImageCreditParams): string | undefined => {
  const valueForTag = (tag: RssImageCreditTag): string | undefined => {
    if (tag === 'media:description') return thumbnailCaption ? htmlToText(thumbnailCaption) : undefined;
    if (tag === 'dc:creator') return thumbnailCreator?.trim();
    if (tag === 'media:copyright') return thumbnailCopyright?.trim();
    return thumbnailCredit?.trim();
  };

  for (const tag of [imageCreditTag || 'media:credit', ...FALLBACK_CREDIT_TAGS]) {
    const value = valueForTag(tag);
    if (value) return value;
  }

  return undefined;
};
